export const HelpSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 14.8C10.95 15.25 10.95 16.15 10.5 16.6C10.05 17.05 9.15 17.05 8.7 16.6C8.25 16.15 8.25 15.25 8.7 14.8C9.15 14.35 10.05 14.35 10.5 14.8ZM6 7.6C6 5.611 7.611 4 9.6 4C11.589 4 13.2 5.611 13.2 7.6C13.2 8.75463 12.489 9.37599 11.7967 9.98099C11.1399 10.5549 10.5 11.1142 10.5 12.1C10.5 12.1 10.5 13 9.6 13C8.7 13 8.7 12.1 8.7 12.1C8.7 10.4609 9.54791 9.81093 10.2934 9.23951C10.8782 8.79125 11.4 8.39129 11.4 7.6C11.4 6.61 10.59 5.8 9.6 5.8C8.61 5.8 7.8 6.61 7.8 7.6C7.8 7.6 7.70199 8.5 6.9 8.5C6.09801 8.5 6 7.6 6 7.6Z"
      fill="currentColor"
    />
    <circle
      cx="9.66663"
      cy="10.3333"
      r="8.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
